import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const buyers = [{
  name: 'Juan',
  city: 'Córdoba',
  province: 'CBA',
  initial: 'J',
  time: 'hace 2 min',
  pack: 'Pack Física Inicial'
}, {
  name: 'María',
  city: 'Rosario',
  province: 'SF',
  initial: 'M',
  time: 'hace 12 min',
  pack: 'Pack Completo VIP'
}, {
  name: 'Carlos',
  city: 'La Plata',
  province: 'BA',
  initial: 'C',
  time: 'hace 45 min',
  pack: 'Pack Completo VIP'
}, {
  name: 'Laura',
  city: 'Mendoza',
  province: 'MZ',
  initial: 'L',
  time: 'hace 3 min',
  pack: 'Pack Física Inicial'
}, {
  name: 'Roberto',
  city: 'Salta',
  province: 'SA',
  initial: 'R',
  time: 'hace 2 horas',
  pack: 'Pack Física + Química'
}, {
  name: 'Ana',
  city: 'Neuquén',
  province: 'NQ',
  initial: 'A',
  time: 'hace 8 min',
  pack: 'Pack Completo VIP'
}, {
  name: 'Diego',
  city: 'Posadas',
  province: 'MS',
  initial: 'D',
  time: 'hace 22 min',
  pack: 'Pack Física Inicial'
}, {
  name: 'Elena',
  city: 'San Miguel',
  province: 'TM',
  initial: 'E',
  time: 'hace 45 seg',
  pack: 'Pack Completo VIP'
}, {
  name: 'Gabriel',
  city: 'Resistencia',
  province: 'CH',
  initial: 'G',
  time: 'hace 15 min',
  pack: 'Pack Física + Química'
}, {
  name: 'Sofía',
  city: 'Santa Rosa',
  province: 'LP',
  initial: 'S',
  time: 'hace 3 horas',
  pack: 'Pack Completo VIP'
}, {
  name: 'Marcos',
  city: 'Ushuaia',
  province: 'TF',
  initial: 'M',
  time: 'hace 7 min',
  pack: 'Pack Física Inicial'
}, {
  name: 'Lucía',
  city: 'Viedma',
  province: 'RN',
  initial: 'L',
  time: 'hace 18 min',
  pack: 'Pack Completo VIP'
}, {
  name: 'Pedro',
  city: 'San Luis',
  province: 'SL',
  initial: 'P',
  time: 'hace 4 min',
  pack: 'Pack Física Inicial'
}, {
  name: 'Florencia',
  city: 'Paraná',
  province: 'ER',
  initial: 'F',
  time: 'hace 55 min',
  pack: 'Pack Física + Química'
}, {
  name: 'Javier',
  city: 'San Salvador',
  province: 'JY',
  initial: 'J',
  time: 'hace 10 min',
  pack: 'Pack Completo VIP'
}];
export function PurchaseToast() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const showNext = () => {
      setIsVisible(true);
      setTimeout(() => setIsVisible(false), 5000);
      setCurrentIndex(prev => (prev + 1) % buyers.length);
    };
    const interval = setInterval(showNext, 15000);
    const initialTimer = setTimeout(showNext, 10000);
    return () => {
      clearInterval(interval);
      clearTimeout(initialTimer);
    };
  }, []);
  const currentBuyer = buyers[currentIndex];
  return <AnimatePresence data-id="element-217">
      {isVisible && <motion.div initial={{
      opacity: 0,
      x: -50
    }} animate={{
      opacity: 1,
      x: 0
    }} exit={{
      opacity: 0,
      x: -50
    }} className="fixed bottom-4 left-4 right-4 md:right-auto z-50 bg-white border border-blue-100 p-3 md:p-4 rounded-xl shadow-2xl flex items-center gap-3 md:gap-4 max-w-sm" data-id="element-218">
          <div className="w-10 h-10 md:w-12 md:h-12 bg-blue-50 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-219">
            <div className="w-8 h-8 md:w-10 md:h-10 bg-blue-600 rounded-full flex items-center justify-center text-white font-bold text-xs md:text-base" data-id="element-220">
              {currentBuyer.initial}
            </div>
          </div>
          <div className="flex-1" data-id="element-221">
            <div className="flex items-center justify-between" data-id="element-222">
              <p className="text-[11px] md:text-sm font-bold text-slate-900" data-id="element-223">
                {currentBuyer.name} de {currentBuyer.city} (
                {currentBuyer.province}){' '}
                <span className="inline-block w-1.5 h-1.5 md:w-2 md:h-2 bg-green-500 rounded-full ml-1" data-id="element-224"></span>
              </p>
              <button onClick={() => setIsVisible(false)} className="text-slate-400 hover:text-slate-600" data-id="element-225">
                <X size={14} data-id="element-226" />
              </button>
            </div>
            <p className="text-xs text-slate-600" data-id="element-227">
              compró el{' '}
              <span className="text-blue-600 font-bold" data-id="element-228">
                {currentBuyer.pack}
              </span>
            </p>
            <p className="text-[10px] text-slate-400 mt-1" data-id="element-229">
              {currentBuyer.time}
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}